type BadgeProps = { isCustom: boolean }
export const Badge = ({ isCustom }: BadgeProps) => {
  return <span className={'tag ml-md' + (isCustom ? ' tag-orange' : '')}>{isCustom ? 'Custom' : 'Default'}</span>
}
